// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/dragula/dist/dragula.css
// module id = ./node_modules/dragula/dist/dragula.css
// module chunks = 4